import { TextField } from "@mui/material";

function EmailInputField ({ label = 'Email', value, onChange, required = false, onEmailError, ...props}) {

    const validateEmail = (email) => {
        //const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const emailRegex = /^(?!.*\.\.)[a-zA-Z0-9#._-]+@[\sa-zA-Z0-9]+(?:\.[\sa-zA-Z]+)+$/;
        return emailRegex.test(email);
    }

    const handleChange = (event) => {
        const email = event.target.value;
        if(onChange){
            onChange(event);
        }

        if(!email){
            if(required){
                onEmailError('Email is Required');
            } else{
                onEmailError(null);
            }
        } else if(!validateEmail(email)){
            onEmailError('Enter valid email');
        } else if((email.split('@')[1].toLocaleLowerCase()).includes('webster')){
            onEmailError('Not a Valid email!');
        }
        else {
            onEmailError(null);
        }
    };

    return(
        <TextField 
            label={label}
            value={value}
            onChange={handleChange}
            required={required}
            {...props}
        />
    );
};

export default EmailInputField;